export const BIA_URL = "https://www.buildinvestinafrica.com";

export const content = {
  fr: {
    nav: {
      activites: "Activités",
      secteurs: "Secteurs",
      digital: "Solutions digitales",
      approche: "Approche",
      contact: "Contact",
    },
    cta: "Échanger sur un projet",
    hero: {
      overline: "Gestion de projets · Développement commercial · Solutions digitales",
      title: "Piloter. Développer. Transformer.",
      subtitle:
        "MKN Projects accompagne entreprises et organisations dans le pilotage de projets complexes, le développement d'opportunités et la conception de solutions digitales adaptées à leurs enjeux opérationnels.",
      tagline: "De l'opportunité à la mise en œuvre.",
      experience: "Plus de dix années d'expérience en gestion de projets industriels et technologiques complexes",
    },
    activites: {
      overline: "Nos activités",
      title: "Deux Business Units complémentaires",
      text: "Deux expertises complémentaires pour transformer les besoins, opportunités et idées en projets structurés et solutions opérationnelles.",
      bu1: {
        label: "Pôle d'activité",
        name: "Gestion de projets & Développement commercial",
        title: "Structurer, développer et piloter des projets complexes.",
        text: "MKN Projects intervient à différentes étapes du cycle de vie d'un projet, depuis l'identification et la qualification d'une opportunité jusqu'au pilotage de son exécution. Selon les besoins, notre intervention peut relever de la gestion de projets, du développement commercial ou combiner les deux approches.",
        skillsLabel: "Compétences",
        sub: [
          {
            id: "gestion-de-projets",
            name: "Gestion de projets",
            hook: "Piloter des projets et programmes complexes dans des environnements multidisciplinaires et exigeants.",
            skills: [
              "Gouvernance et organisation projet",
              "Planification et pilotage des jalons",
              "Pilotage coûts, qualité et délais",
              "Suivi de la performance",
              "Coordination d'équipes multidisciplinaires",
              "Gestion des risques et opportunités",
              "Gestion des interfaces techniques et organisationnelles",
              "Pilotage fournisseurs et partenaires",
              "Reporting et aide à la décision",
              "Accompagnement jusqu'à la livraison",
            ],
            badge: "Expertise en gestion de projets certifiée PMP®",
            more: "/gestion-de-projets",
          },
          {
            id: "developpement-commercial",
            name: "Développement commercial",
            hook: "Transformer une opportunité ou un besoin identifié en projet structuré et réalisable.",
            skills: [
              "Identification et qualification d'opportunités",
              "Analyse et clarification des besoins",
              "Développement de nouveaux marchés et activités",
              "Structuration de projets et d'offres",
              "Recherche et qualification de partenaires",
              "Mobilisation de partenaires techniques et industriels",
              "Identification de solutions de financement",
              "Développement de partenariats",
              "Construction et coordination de consortiums",
              "Coordination des parties prenantes",
              "Accompagnement jusqu'à la contractualisation et au lancement",
            ],
          },
        ],
        continuity:
          "Selon la nature de la mission, MKN Projects peut intervenir en gestion de projets, en développement commercial, ou assurer la continuité entre développement de l'opportunité, structuration du projet et pilotage de sa mise en œuvre.",
      },
    },
    secteurs: {
      overline: "Secteurs d'expertise",
      title: "Des environnements technologiques et industriels exigeants",
      text: "Notre expérience s'est construite sur des projets complexes caractérisés par de fortes contraintes techniques, de multiples interfaces et la coordination de nombreux métiers et parties prenantes.",
      seeAlso: "Voir aussi",
      roleLabel: "Le rôle de MKN Projects",
      items: [
        {
          id: "aeronautique-defense",
          name: "Aéronautique & Défense",
          hook: "Piloter des projets et systèmes complexes pour plateformes aériennes et applications de défense.",
          text: "MKN Projects s'appuie sur plus de dix années d'expérience en gestion de projets dans les secteurs aéronautique et défense, sur des systèmes associant logiciels, électronique, équipements embarqués et multiples interfaces techniques.",
          domains: [
            "Systèmes embarqués",
            "Équipements avioniques",
            "Systèmes de communication pour aéronefs",
            "Intégration de systèmes",
            "Logiciels pour plateformes aériennes non habitées",
            "Coordination logiciel / matériel",
            "Gestion de projets et programmes complexes",
          ],
          note: "Secteur historique d'expertise de MKN Projects.",
          links: [{ label: "Gestion de projets & programmes", href: "/gestion-de-projets" }],
          more: "/aeronautique-defense",
        },
        {
          id: "industrie-technologies",
          name: "Industrie & Technologies",
          hook: "Développer et piloter des projets technologiques et industriels complexes.",
          text: "MKN Projects intervient sur des projets combinant systèmes connectés, infrastructures intelligentes, technologies de communication, équipements industriels et solutions énergétiques.",
          families: [
            {
              name: "Systèmes intelligents & connectés",
              text: "Pilotage de projets intégrant équipements connectés, communications et systèmes industriels intelligents.",
              domains: [
                "Comptage intelligent",
                "Systèmes de comptage communicants",
                "IoT industriel",
                "Communications LoRa",
                "Équipements connectés",
                "Interfaces logiciel / matériel",
              ],
            },
            {
              name: "Énergie & électrification",
              text: "Structuration et développement de projets d'énergie solaire, d'électrification et d'infrastructures associées, depuis la qualification du besoin jusqu'à la mobilisation des partenaires nécessaires à leur réalisation.",
              domains: [
                "Centrales solaires",
                "Électrification",
                "Infrastructures énergétiques",
                "Stockage d'énergie",
                "Structuration de projets",
                "Recherche de partenaires techniques",
                "Recherche de partenaires industriels",
                "Recherche de solutions de financement",
                "Développement commercial",
                "Gestion de projets",
              ],
              roles: [
                { name: "Qualifier", detail: "Comprendre le besoin et l'opportunité" },
                { name: "Structurer", detail: "Transformer le besoin en projet organisé" },
                { name: "Mobiliser", detail: "Réunir les partenaires techniques, industriels et financiers adaptés" },
                { name: "Coordonner", detail: "Assurer les interfaces entre les différentes parties" },
                { name: "Piloter", detail: "Accompagner le projet jusqu'à sa réalisation" },
              ],
            },
            {
              name: "Projets technologiques",
              text: "Pilotage de projets multidisciplinaires associant matériel, logiciel, systèmes de communication, fournisseurs et processus industriels. Une compétence centrale de MKN Projects, mobilisable indépendamment du secteur.",
              domains: [],
            },
          ],
          links: [
            { label: "Gestion de projets & programmes", href: "/gestion-de-projets" },
            { label: "Développement commercial", href: "#developpement-commercial" },
          ],
        },
      ],
    },
    digital: {
      label: "Pôle d'activité",
      name: "Solutions digitales",
      title: "Concevoir des solutions digitales répondant à des besoins métier concrets.",
      text: "MKN Projects développe des solutions digitales destinées à structurer les processus, exploiter les données, automatiser certaines activités et améliorer le pilotage et la prise de décision.",
      items: [
        "Applications métier",
        "Solutions SaaS",
        "Digitalisation des processus",
        "Automatisation des workflows",
        "Data & Analytics",
        "Intelligence artificielle appliquée",
        "Tableaux de bord",
        "Reporting opérationnel",
        "Outils de pilotage",
      ],
      bia: {
        label: "Une solution digitale de MKN Projects",
        title: "BIA — Build & Invest in Africa",
        hook: "Structurer, accompagner et piloter la progression des projets entrepreneuriaux.",
        text: "BIA est une plateforme destinée aux entrepreneurs, PME, incubateurs, programmes et institutions pour accompagner la structuration et la progression des projets vers le financement.",
        path: ["Diagnostiquer", "Structurer", "Accompagner", "Orienter", "Mesurer"],
        audiences: [
          {
            name: "Pour les entrepreneurs et PME",
            text: "Évaluer la maturité du projet, identifier les priorités, structurer ses différentes dimensions et progresser vers le financement.",
          },
          {
            name: "Pour les institutions et programmes",
            text: "Piloter des cohortes, suivre la progression des bénéficiaires, identifier les points de blocage et mesurer leur niveau de préparation.",
          },
        ],
        programs: {
          name: "BIA Programs",
          text: "La solution dédiée aux incubateurs, programmes d'accompagnement, institutions et réseaux entrepreneuriaux.",
        },
        cta: "Découvrir BIA",
      },
    },
    approche: {
      overline: "Notre approche",
      title: "De l'opportunité à la réalisation",
      text: "MKN Projects combine compréhension technique, développement commercial et gestion de projets afin de transformer un besoin ou une opportunité en projet structuré et d'accompagner sa mise en œuvre.",
      steps: [
        { name: "Comprendre", detail: "Analyser le besoin, le contexte, les objectifs et les contraintes." },
        { name: "Structurer", detail: "Définir le périmètre, les exigences, l'organisation, les ressources et les prochaines étapes." },
        { name: "Mobiliser", detail: "Identifier et coordonner les expertises, partenaires et parties prenantes nécessaires." },
        { name: "Piloter", detail: "Maîtriser coûts, qualité, délais, risques, interfaces et performance." },
        { name: "Déployer", detail: "Accompagner l'exécution, la livraison et la mise en œuvre opérationnelle." },
      ],
    },
    modes: {
      overline: "Modes d'intervention",
      title: "Une intervention adaptée à chaque projet",
      highlight: "Capacité différenciante",
      items: [
        {
          name: "Gestion de projets & programmes",
          text: "Renforcer ou prendre en charge le pilotage d'un projet ou programme complexe, depuis sa structuration jusqu'à sa livraison.",
        },
        {
          name: "Développement commercial",
          text: "Identifier, qualifier et développer des opportunités, marchés et partenariats.",
        },
        {
          name: "Accompagnement de bout en bout",
          text: "Assurer la continuité entre développement de l'opportunité, structuration du projet, mobilisation des partenaires et pilotage de sa réalisation.",
        },
      ],
    },
    expertise: {
      overline: "Expertise",
      title: "Une expérience issue de projets industriels complexes",
      text: "MKN Projects s'appuie sur plus de dix années d'expérience en gestion de projets dans des environnements industriels et technologiques exigeants, notamment dans l'aéronautique et la défense. Cette expertise est aujourd'hui mobilisée pour accompagner des projets dans l'industrie, les technologies, l'énergie et le digital.",
      certification: "Certification Project Management Professional (PMP®).",
      pillars: [
        { name: "Complexité", text: "Projets à fortes contraintes et multiples interfaces" },
        { name: "Multidisciplinaire", text: "Coordination de métiers techniques et fonctions support" },
        { name: "International", text: "Collaboration entre partenaires et organisations de différents environnements" },
        { name: "Performance", text: "Orientation coûts, qualité, délais, risques et résultats" },
      ],
    },
    international: {
      title: "France · Europe · Afrique",
      text: "Basée en France, MKN Projects accompagne des projets impliquant des acteurs français et internationaux et développe des collaborations entre entreprises, partenaires techniques, industriels, institutions et écosystèmes européens et africains.",
    },
    contact: {
      overline: "Contact",
      title: "Un projet, un besoin ou une opportunité à structurer ?",
      text: "Échangeons sur vos enjeux et les prochaines étapes.",
      form: {
        name: "Nom",
        company: "Entreprise",
        email: "Email",
        message: "Message",
        submit: "Nous contacter",
        sending: "Envoi en cours…",
      },
      success: "Message envoyé. Nous revenons vers vous rapidement.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    footer: {
      tagline: "Gestion de projets · Développement commercial · Solutions digitales",
      legal: "Micro-entreprise française · Dirigée par Paul Mukuna",
      links: { legal: "Mentions légales", privacy: "Confidentialité", contact: "Contact" },
      legalContent: [
        "Éditeur du site : MKN Projects — Micro-entreprise française dirigée par Paul Mukuna. SIRET : 843 416 942. Siège : France.",
        "Directeur de la publication : Paul Mukuna.",
        "Ce site a pour objet de présenter les activités de MKN Projects : gestion de projets, développement commercial et solutions digitales.",
      ],
      privacyContent: [
        "Les informations transmises via le formulaire de contact (nom, entreprise, email, message) sont utilisées exclusivement pour répondre à votre demande.",
        "Aucune donnée n'est cédée à des tiers ni utilisée à des fins commerciales.",
        "Vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous via le formulaire de contact.",
      ],
    },
  },
  en: {
    nav: {
      activites: "Activities",
      secteurs: "Sectors",
      digital: "Digital solutions",
      approche: "Approach",
      contact: "Contact",
    },
    cta: "Discuss a project",
    hero: {
      overline: "Project Management · Business Development · Digital Solutions",
      title: "Pilot. Develop. Transform.",
      subtitle:
        "MKN Projects supports companies and organisations in steering complex projects, developing opportunities and designing digital solutions tailored to their operational challenges.",
      tagline: "From opportunity to implementation.",
      experience: "Over ten years of experience managing complex industrial and technological projects",
    },
    activites: {
      overline: "Our activities",
      title: "Two complementary Business Units",
      text: "Two complementary areas of expertise to turn needs, opportunities and ideas into structured projects and operational solutions.",
      bu1: {
        label: "Practice",
        name: "Project Management & Business Development",
        title: "Structuring, developing and steering complex projects.",
        text: "MKN Projects operates at different stages of a project's life cycle, from identifying and qualifying an opportunity through to steering its execution. Depending on the need, our involvement may fall under project management, business development, or combine both approaches.",
        skillsLabel: "Capabilities",
        sub: [
          {
            id: "gestion-de-projets",
            name: "Project Management",
            hook: "Steering complex projects and programmes in demanding, multidisciplinary environments.",
            skills: [
              "Project governance and organisation",
              "Planning and milestone management",
              "Cost, quality and schedule control",
              "Performance monitoring",
              "Coordination of multidisciplinary teams",
              "Risk and opportunity management",
              "Technical and organisational interface management",
              "Supplier and partner management",
              "Reporting and decision support",
              "Support through to delivery",
            ],
            badge: "PMP®-certified project management expertise",
            more: "/gestion-de-projets",
          },
          {
            id: "developpement-commercial",
            name: "Business Development",
            hook: "Turning an identified opportunity or need into a structured, achievable project.",
            skills: [
              "Opportunity identification and qualification",
              "Needs analysis and clarification",
              "Development of new markets and activities",
              "Project and offer structuring",
              "Partner search and qualification",
              "Mobilisation of technical and industrial partners",
              "Identification of financing solutions",
              "Partnership development",
              "Consortium building and coordination",
              "Stakeholder coordination",
              "Support through to contracting and launch",
            ],
          },
        ],
        continuity:
          "Depending on the nature of the assignment, MKN Projects can act in project management, in business development, or ensure continuity between developing the opportunity, structuring the project and steering its implementation.",
      },
    },
    secteurs: {
      overline: "Sectors of expertise",
      title: "Demanding technological and industrial environments",
      text: "Our experience has been built on complex projects characterised by strong technical constraints, multiple interfaces and the coordination of many disciplines and stakeholders.",
      seeAlso: "See also",
      roleLabel: "The role of MKN Projects",
      items: [
        {
          id: "aeronautique-defense",
          name: "Aerospace & Defence",
          hook: "Steering complex projects and systems for airborne platforms and defence applications.",
          text: "MKN Projects draws on more than ten years of project management experience in the aerospace and defence sectors, on systems combining software, electronics, on-board equipment and multiple technical interfaces.",
          domains: [
            "Embedded systems",
            "Avionics equipment",
            "Aircraft communication systems",
            "Systems integration",
            "Software for unmanned aerial platforms",
            "Software / hardware coordination",
            "Complex project and programme management",
          ],
          note: "MKN Projects' historical sector of expertise.",
          links: [{ label: "Project & programme management", href: "/gestion-de-projets" }],
          more: "/aeronautique-defense",
        },
        {
          id: "industrie-technologies",
          name: "Industry & Technologies",
          hook: "Developing and steering complex technological and industrial projects.",
          text: "MKN Projects works on projects combining connected systems, smart infrastructure, communication technologies, industrial equipment and energy solutions.",
          families: [
            {
              name: "Smart & connected systems",
              text: "Managing projects that integrate connected equipment, communications and smart industrial systems.",
              domains: [
                "Smart metering",
                "Communicating metering systems",
                "Industrial IoT",
                "LoRa communications",
                "Connected equipment",
                "Software / hardware interfaces",
              ],
            },
            {
              name: "Energy & electrification",
              text: "Structuring and developing solar energy, electrification and related infrastructure projects, from qualifying the need through to mobilising the partners required to deliver them.",
              domains: [
                "Solar power plants",
                "Electrification",
                "Energy infrastructure",
                "Energy storage",
                "Project structuring",
                "Technical partner search",
                "Industrial partner search",
                "Financing solution search",
                "Business development",
                "Project management",
              ],
              roles: [
                { name: "Qualify", detail: "Understand the need and the opportunity" },
                { name: "Structure", detail: "Turn the need into an organised project" },
                { name: "Mobilise", detail: "Bring together the right technical, industrial and financial partners" },
                { name: "Coordinate", detail: "Manage the interfaces between the different parties" },
                { name: "Steer", detail: "Support the project through to delivery" },
              ],
            },
            {
              name: "Technology projects",
              text: "Managing multidisciplinary projects combining hardware, software, communication systems, suppliers and industrial processes. A core capability of MKN Projects, applicable regardless of sector.",
              domains: [],
            },
          ],
          links: [
            { label: "Project & programme management", href: "/gestion-de-projets" },
            { label: "Business Development", href: "#developpement-commercial" },
          ],
        },
      ],
    },
    digital: {
      label: "Practice",
      name: "Digital Solutions",
      title: "Designing digital solutions that address concrete business needs.",
      text: "MKN Projects develops digital solutions designed to structure processes, leverage data, automate certain activities and improve management and decision-making.",
      items: [
        "Business applications",
        "SaaS solutions",
        "Process digitalisation",
        "Workflow automation",
        "Data & Analytics",
        "Applied artificial intelligence",
        "Dashboards",
        "Operational reporting",
        "Management tools",
      ],
      bia: {
        label: "A digital solution by MKN Projects",
        title: "BIA — Build & Invest in Africa",
        hook: "Structuring, supporting and tracking the progress of entrepreneurial projects.",
        text: "BIA is a platform for entrepreneurs, SMEs, incubators, programmes and institutions, supporting the structuring and progression of projects towards financing.",
        path: ["Diagnose", "Structure", "Support", "Guide", "Measure"],
        audiences: [
          {
            name: "For entrepreneurs and SMEs",
            text: "Assess project maturity, identify priorities, structure its different dimensions and progress towards financing.",
          },
          {
            name: "For institutions and programmes",
            text: "Manage cohorts, track beneficiaries' progress, identify blocking points and measure their level of readiness.",
          },
        ],
        programs: {
          name: "BIA Programs",
          text: "The solution dedicated to incubators, support programmes, institutions and entrepreneurial networks.",
        },
        cta: "Discover BIA",
      },
    },
    approche: {
      overline: "Our approach",
      title: "From opportunity to delivery",
      text: "MKN Projects combines technical understanding, business development and project management to turn a need or an opportunity into a structured project and support its implementation.",
      steps: [
        { name: "Understand", detail: "Analyse the need, the context, the objectives and the constraints." },
        { name: "Structure", detail: "Define the scope, requirements, organisation, resources and next steps." },
        { name: "Mobilise", detail: "Identify and coordinate the required expertise, partners and stakeholders." },
        { name: "Steer", detail: "Control costs, quality, schedule, risks, interfaces and performance." },
        { name: "Deploy", detail: "Support execution, delivery and operational implementation." },
      ],
    },
    modes: {
      overline: "Engagement models",
      title: "An engagement tailored to each project",
      highlight: "Differentiating capability",
      items: [
        {
          name: "Project & programme management",
          text: "Reinforce or take charge of the management of a complex project or programme, from structuring through to delivery.",
        },
        {
          name: "Business development",
          text: "Identify, qualify and develop opportunities, markets and partnerships.",
        },
        {
          name: "End-to-end support",
          text: "Ensure continuity between developing the opportunity, structuring the project, mobilising partners and steering its delivery.",
        },
      ],
    },
    expertise: {
      overline: "Expertise",
      title: "Experience built on complex industrial projects",
      text: "MKN Projects draws on more than ten years of project management experience in demanding industrial and technological environments, particularly in aerospace and defence. This expertise is now applied to support projects in industry, technology, energy and digital.",
      certification: "Project Management Professional (PMP®) certification.",
      pillars: [
        { name: "Complexity", text: "Projects with strong constraints and multiple interfaces" },
        { name: "Multidisciplinary", text: "Coordination of technical disciplines and support functions" },
        { name: "International", text: "Collaboration between partners and organisations from different environments" },
        { name: "Performance", text: "Focus on costs, quality, schedule, risks and results" },
      ],
    },
    international: {
      title: "France · Europe · Africa",
      text: "Based in France, MKN Projects supports projects involving French and international stakeholders and develops collaborations between companies, technical and industrial partners, institutions and European and African ecosystems.",
    },
    contact: {
      overline: "Contact",
      title: "A project, a need or an opportunity to structure?",
      text: "Let's discuss your challenges and the next steps.",
      form: {
        name: "Name",
        company: "Company",
        email: "Email",
        message: "Message",
        submit: "Contact us",
        sending: "Sending…",
      },
      success: "Message sent. We will get back to you shortly.",
      error: "An error occurred. Please try again.",
    },
    footer: {
      tagline: "Project Management · Business Development · Digital Solutions",
      legal: "French micro-enterprise · Led by Paul Mukuna",
      links: { legal: "Legal notice", privacy: "Privacy", contact: "Contact" },
      legalContent: [
        "Site publisher: MKN Projects — French micro-enterprise led by Paul Mukuna. SIRET: 843 416 942. Registered in France.",
        "Publication director: Paul Mukuna.",
        "This site presents the activities of MKN Projects: project management, business development and digital solutions.",
      ],
      privacyContent: [
        "Information submitted via the contact form (name, company, email, message) is used exclusively to respond to your request.",
        "No data is shared with third parties or used for commercial purposes.",
        "You have the right to access, rectify and delete your data. To exercise it, contact us via the contact form.",
      ],
    },
  },
};
